module.exports = __webpack_public_path__ + "img/eu.7aea52bb.svg";